import { Link } from "react-router-dom";
import Header from "../components/Header";

const TrungTamAnToan = () => {
  const listMenu = [
    {
      name: "Mật khẩu đăng nhập",
      img: <i className="fa-solid fa-lock"></i>,
      path: "/mat-khau-dang-nhap",
    },
    {
      name: "Mật khẩu rút tiền",
      img: <i className="fa-solid fa-key"></i>,
      path: "/mat-khau-rut-tien",
    },
  ];
  return (
    <div className="wrapper">
      <div className="container-web account bgnew">
        <div className="header-account">
          <Header title="Trung tâm an toàn" />
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: 130 }}
          >
            <span style={{ fontSize: 16 }}>Mức độ an toàn: Cao</span>
          </div>
        </div>
        <main>
          {listMenu?.map((item, index) => {
            return (
              <Link
                to={item.path}
                key={index}
                className="d-flex align-items-center w-100 text-decoration-none gap-2 justify-content-between py-3 px-3"
                style={{ borderBottom: "1px solid #404040" }}
              >
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ fontSize: 14, color: "#fff" }}
                >
                  <span style={{ fontSize: 15, color: "#d5b377" }}>
                    {item.img}
                  </span>
                  <div>{item.name}</div>
                </div>
                <div style={{ fontSize: 15, color: "#f7d6a5" }}>
                  <i className="fa-solid fa-chevron-right"></i>
                </div>
              </Link>
            );
          })}

          <p className="p-3" style={{ fontSize: 13, color: "#9c9c9c" }}>
            Để đảm bảo an toàn cho tiền của bạn, bạn phải thực hiện các thao tác
            sau để rút tiền mặt
            <br />
            1. Chưa đặt mật khẩu rút tiền
          </p>
        </main>
      </div>
    </div>
  );
};

export default TrungTamAnToan;
